<template>
  <div class="flex-1 page-header analytics-width-tracker">
    <div class="border-bottom page-header__path">
      <ul class="breadcrumb mb-0 px-0">
        <li class="breadcrumb-item">
          <icon
            icon="minilogo"
            class="mr-1"
          />
          <router-link
            :to="{ name: 'dashboard' }"
          >
            Tellimer
          </router-link>
        </li>
        <li
          v-for="(name, index) in routeName"
          :key="index"
          class="breadcrumb-item"
          :class="{ 'breadcrum-item-active': index+1 === routeName.length }"
        >
          <router-link
            v-if="index+1 !== routeName.length"
            :to="{ name }"
          >
            {{ capitalize(name) }}
          </router-link>
          <span v-else>
            {{ capitalize(name) }}
          </span>
        </li>
      </ul>
    </div>
    <div class="d-flex align-items-center border-bottom page-header__name">
      <div class="page-header-title">
        <h1 class="d-flex flex-wrap align-items-center align-self-center text-black mb-0 mr-2">
          {{ header }}
          <slot name="suffix" />
        </h1>
        <span class="subtitle-wrapper">
          <slot name="subtitle" />
        </span>
      </div>
      <div class="d-flex ml-auto slot-wrapper">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    header: {
      required: true,
      type: String,
    },
  },
  computed: {
    routeName () {
      return this.$route.name.split('.')
    },
  },
  methods: {
    capitalize (string) {
      return string.charAt(0).toUpperCase() + string.slice(1).replace(/-/g, ' ')
    },
  },
}
</script>

<style lang="scss">
.page-header {
  h1 {
    color: #1f2638;
  }
  .breadcrumb {
    color: #757575;
    font-size: 14px;
    a {
      color: #adadad;
    }
  }
  .breadcrumb-item + .breadcrumb-item {
    padding-left: .2rem;
  }
  .breadcrumb-item + .breadcrumb-item::before {
    padding-right: .2rem;
    width: .8rem;
    top: 2px;
    position: relative;
  }
  .page-header {
    &__path {
      span {
        font-size: 14px;
      }
    }

    &__name {
      padding: 24px 0;

      h1 {
        margin-bottom: 8px;
      }
    }
  }

  .page-header-title {
    flex: 1 0 50%;
  }

  .slot-wrapper {
  }
}
</style>
